import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { Col, Form, Image, Input, Row, Select, DatePicker, TabsProps, Tabs } from "antd";
import { useStore } from "../../store";
import dayjs from 'dayjs';
import locale from 'antd/es/date-picker/locale/zh_CN';
import HtmlToReactParser from "html-to-react";
import { BaseImageUrl } from "../../http/http";

const defaultIcon = require("../../image/default-pic.png")

const ScienceDetail:React.FC = () => {

    const [form] = Form.useForm();
    const { scienceStore } = useStore();
    const [type, setType] = useState("1");
    const dataFormat = 'YYYY-MM-DD HH:mm:ss';
    useEffect(() => {
        const { showBaseLibraryDetail } = scienceStore;
        const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));
        detail.state = detail.state.toString();
        detail.createtime = dayjs(detail.createtime, dataFormat);
        form.setFieldsValue(detail);
    }, []);

    const tabItems:TabsProps['items'] = [
        {
            key: "1",
            label: "文章信息",
        },
        {
            key: "2",
            label: "文章详情",
        }
    ]
    const onTabChange = (key: string) => {
        setType(key);
    }
    const scienceForm = () => {
        return <Form preserve={false} title={"科普宣传信息"} disabled={true} form={form} layout={"vertical"} size={"middle"} style={{minHeight: '400px'}}>
            <Row gutter={24}>
            <Col span={8}>
                    <Form.Item label={"分类:"} name={"category"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"标题:"} name={"title"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"数据来源:"} name={"source"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"状态:"} name={"state"} required={true}>
                        <Select
                            defaultValue="1"
                            options={[
                                { value: '1', label: '发布' },
                                { value: '-1', label: '下线' },
                                { value: '-2', label: '删除' }
                            ]}
                            />
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"文章作者:"} name={"autor"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"更新时间:"} name={"createtime"} required={true}><DatePicker locale={locale} format={dataFormat}/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"头像:"} name={"createtime"} required={true}>
                        <Image style={{ width: '64px', height: '64px' }} preview={false} src={scienceStore.srcCoverFile ? scienceStore.srcCoverFile : BaseImageUrl+scienceStore.showBaseLibraryDetail?.userImg} fallback={defaultIcon}/>
                    </Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"封面图:"} name={"createtime"} required={true}>
                        <Image style={{ width: '100%', height: '200px' }} preview={false} src={scienceStore.srcCoverFile ? scienceStore.srcCoverFile : BaseImageUrl+scienceStore.showBaseLibraryDetail?.cover} fallback={defaultIcon}/>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    }
    const scienceDetail = ()=> {
        return (<div style={{height: '600px'}}>
            {HtmlToReactParser.Parser().parse(scienceStore.showBaseLibraryDetail?.content)}
        </div>)
    }

    return(<Wrapper>
        <Tabs items={tabItems} onChange={onTabChange}/>
        <div style={{paddingBottom:"16px"}}>
            {Number(type) === 1 && scienceForm()}
            {Number(type) === 2 && scienceDetail()}
        </div>
    </Wrapper>);
}

export default ScienceDetail;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 15px 30px;
  height: 700px;
  overflow: auto;
  .ant-picker{
    width: 100%;
  }
`;
const secondTitle = styled.div`
  & {
    font-size: 17px;
    line-height: 17px;
    margin: 10px 0;
  }
`;